<input type="checkbox" id="notificationSettingsModal" class="modal-toggle" [checked]="isModalOpen" />
<div class="modal" role="dialog" *ngIf="isModalOpen">
  <div class="modal-box flex !overflow-visible flex-col p-0">
    <div class="flex justify-between items-center border-b-[1px] border-white-shades-500 p-4 pb-3">
      <h1 class="font-medium text-secondary-color-500 text-base">{{'project-overview.notification' | translate}}</h1>
      <button (click)="closeModal()" class="btn btn-circle btn-link btn-xs">
        <app-svg-icon [src]="exitIcon" width="24px" height="24px"/>
      </button>
    </div>
    <form [formGroup]="notificationForm" class="form-control flex flex-col flex-1 px-4 py-6 gap-y-6">
      <div role="alert" class="flex items-center justify-between gap-2">
        <div class="flex items-center justify-start gap-2">
          <a href="https://docs.bavox.ch/" target="_blank">
            <app-svg-icon [src]="exclamationMarkCircleIcon" stroke="#001a30" />
          </a>
          <p class="text-secondary-color-500 break-words break-all">{{'project-overview.define-notification-inteval' | translate}}</p>
        </div>
        <input
          formControlName="isEnabled"
          class="toggle toggle-primary"
          type="checkbox"
        />
      </div>

      <ng-container *ngIf="notificationForm.get('isEnabled')?.value">
        <div *ngFor="let freq of notificationFrequencies; let i = index" class="flex flex-col space-y-3">
          <div class="flex items-center gap-2">
            <input
              type="radio"
              name="frequency"
              formControlName="frequency"
              [value]="freq"
              class="radio radio-primary"
            />
            <span class="label-text">
              {{ getFrequencyLabel(freq) | translate }}
            </span>
          </div>
        
          <div *ngIf="notificationForm.get('frequency')?.value === NotificationFrequency.CUSTOM_INTERVAL && freq === NotificationFrequency.CUSTOM_INTERVAL" class="input-wrapper">
            <input
              type="number"
              formControlName="customIntervalMinutes"
              placeholder="{{'project-overview.minute' | translate}}"
              class="!h-[42px] w-full max-w-1/2"
            />
            <p
              class="input-error-message"
              *ngIf="notificationForm.get('customIntervalMinutes')?.hasError('required') && (notificationForm.get('customIntervalMinutes')?.dirty || notificationForm.get('customIntervalMinutes')?.touched)"
            >
              {{'project-overview.minute' | translate}} {{'project-overview.is-required' | translate}}
            </p>
          </div>
        
          <app-time-picker
            *ngIf="notificationForm.get('frequency')?.value === NotificationFrequency.DAILY && freq === NotificationFrequency.DAILY"
            [control]="dailyTimeControl"
            placeholder="Select time">
          </app-time-picker>
        </div>
      </ng-container>
      
      <div class="col-span-5 flex justify-end items-center gap-3">
        <button
          type="button"
          (click)="closeModal()"
          class="btn btn-link btn-link-neutral btn-sm min-w-[134px]"
        >
          {{'project-overview.cancel' | translate}}
        </button>
        <button
          [disabled]="((!!sharedLinkId) && (!!token)) || !isValueChanged() || notificationSettingsLoading"
          type="button"
          (click)="onChangeNotificationSettings()"
          class="btn btn-primary btn-sm min-w-[134px]"
        >
          <span *ngIf="notificationSettingsLoading" class="loading loading-spinner"></span>
          <span *ngIf="!notificationSettingsLoading">{{'project-overview.change' | translate}}</span>
        </button>
      </div>
    </form>
  </div>
  <label (click)="closeModal()" class="modal-backdrop"></label>
</div>
